<div class="content-header pt-4 pb-2">
    <div class="container-fluid">
        <div class="row align-items-center mb-3">
            <div class="col-sm-6 d-flex align-items-center">
                <h1 class="m-0 text-light mr-2 page-title">Products</h1>
                <button type="button" class="btn btn-primary btn-add" (click)="openAddModal()">
                    <i class="fas fa-plus"></i>
                </button>
            </div>
            <div class="col-sm-6">
                <!-- <ol class="breadcrumb float-sm-right"> ... </ol> hidden to match mockup simplicity -->
            </div>
        </div>
    </div>
</div>

<section class="content">
    <div class="container-fluid">
        <!-- Floating white table container (matches mockup) -->
        <div class="mockup-table-container">
            <table class="table table-hover table-borderless text-center align-middle empty-table">
                <thead>
                    <tr>
                        <th width="10%">Sr.No</th>
                        <th width="15%">Image</th>
                        <th width="25%">Product Code</th>
                        <th width="25%">Product Name</th>
                        <th width="13%">Actions</th>
                        <th width="12%">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Loading state -->
                    <tr *ngIf="isLoading">
                        <td colspan="6" class="text-muted py-4">Loading products...</td>
                    </tr>

                    <!-- Empty state -->
                    <tr *ngIf="!isLoading && products.length === 0">
                        <td colspan="6" class="text-muted py-4">No products found. Add a new product to get started.
                        </td>
                    </tr>

                    <!-- Data rows -->
                    <tr *ngFor="let prod of products; let i = index">
                        <td class="text-muted">{{ i + 1 }}</td>
                        <td>
                            <img *ngIf="prod.imageDetails && prod.imageDetails.length > 0"
                                [src]="getProductImageUrl(prod.imageDetails[0].imageDetailsId)" alt="Product Image"
                                style="max-height: 50px; border-radius: 4px; border: 1px solid #eee;">
                            <span *ngIf="!prod.imageDetails || prod.imageDetails.length === 0"
                                class="text-muted small">No Image</span>
                        </td>
                        <td class="font-weight-bold text-dark">{{ prod.productCode }}</td>
                        <td class="text-muted">{{ prod.productName }}</td>
                        <td class="action-icons">
                            <a href="javascript:void(0)" class="text-success mx-2" title="View"
                                (click)="openViewModal(prod)"><i class="fas fa-eye"></i></a>
                            <a href="javascript:void(0)" class="text-primary mx-2" title="Edit"
                                (click)="openEditModal(prod)"><i class="fas fa-edit"></i></a>
                        </td>
                        <td>
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input"
                                    id="customSwitchProd-{{prod.productId}}"
                                    [checked]="prod.availability === 'IN_STOCK'"
                                    (change)="toggleProductAvailability(prod, $event)">
                                <label class="custom-control-label" for="customSwitchProd-{{prod.productId}}"></label>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<!-- Add / Edit Modal Overlay -->
<div class="custom-modal-backdrop" *ngIf="isModalOpen">
    <div class="custom-modal custom-modal-xxl">
        <div class="custom-modal-header">
            <h5 class="m-0">{{ isEditMode ? 'Edit Product' : 'Add New Product' }}</h5>
            <button class="close-btn" (click)="closeModal()">&times;</button>
        </div>
        <div class="custom-modal-body">
            <form [formGroup]="productForm" (ngSubmit)="saveProduct()">
                <div class="row">
                    <div class="col-md-6 form-group">
                        <label>Product Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="productName"
                            placeholder="Enter product name">
                        <span class="text-danger font-weight-bold" style="font-size: 12px"
                            *ngIf="productFormErrors.productName">
                            {{productFormErrors.productName}}
                        </span>
                    </div>
                    <div class="col-md-6 form-group">
                        <label>Product Code <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="productCode" placeholder="Enter code">
                        <span class="text-danger font-weight-bold" style="font-size: 12px"
                            *ngIf="productFormErrors.productCode">
                            {{productFormErrors.productCode}}
                        </span>
                    </div>
                </div>

                <div class="form-group">
                    <label>Description</label>
                    <textarea class="form-control" formControlName="description" rows="3"
                        placeholder="Enter description"></textarea>
                </div>

                <div class="row">
                    <div class="col-md-4 form-group">
                        <label>Category <span class="text-danger">*</span></label>
                        <select class="form-control" formControlName="categoryId">
                            <option [ngValue]="null">Select Category</option>
                            <option *ngFor="let cat of categories" [value]="cat.categoryId">{{ cat.categoryName }}
                            </option>
                        </select>
                        <span class="text-danger font-weight-bold" style="font-size: 12px"
                            *ngIf="productFormErrors.categoryId">
                            {{productFormErrors.categoryId}}
                        </span>
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Price <span class="text-danger">*</span></label>
                        <input type="number" class="form-control" formControlName="price">
                        <span class="text-danger font-weight-bold" style="font-size: 12px"
                            *ngIf="productFormErrors.price">
                            {{productFormErrors.price}}
                        </span>
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Quantity <span class="text-danger">*</span></label>
                        <input type="number" class="form-control" formControlName="totalQuantity">
                        <span class="text-danger font-weight-bold" style="font-size: 12px"
                            *ngIf="productFormErrors.totalQuantity">
                            {{productFormErrors.totalQuantity}}
                        </span>
                    </div>
                </div>

                <!-- Product Images Section -->
                <div class="product-image-section mt-3 mb-3">
                    <label>Product Images</label>
                    <div class="d-flex align-items-center flex-wrap">
                        <div class="mr-3 mb-2">
                            <input type="file" accept=".jpg,.jpeg,.png" class="d-none" #productImageInput
                                (change)="onProductImageSelected($event)">
                            <button type="button" class="btn btn-sm btn-outline-secondary"
                                (click)="productImageInput.click()">
                                <i class="fas fa-upload mr-1"></i> Add Image
                            </button>
                        </div>
                        <div *ngFor="let img of productImageFiles; let imgIdx = index"
                            class="product-image-preview mr-2 mb-2">
                            <img [src]="img.preview" alt="Product image" class="product-thumb">
                            <button type="button" class="btn btn-sm text-danger remove-img-btn"
                                (click)="removeProductImage(imgIdx)" title="Remove image">
                                <i class="fas fa-times-circle"></i>
                            </button>
                        </div>
                    </div>
                    <div class="text-muted small mb-1 mt-1">
                        Max 2MB. Accepted formats: JPG, PNG.
                    </div>
                </div>

                <!-- Models & Specifications Dynamic FormArray -->
                <div formArrayName="models">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="font-weight-bold m-0 text-dark">Models & Specifications</h6>
                    </div>

                    <div *ngFor="let model of modelsArray.controls; let mIndex = index" [formGroupName]="mIndex"
                        class="model-container border rounded p-3 mb-3 bg-light">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <strong>Models & Specifications details</strong>
                            <button *ngIf="modelsArray.length > 1" type="button" class="btn btn-sm text-danger"
                                (click)="removeModel(mIndex)"><i class="fas fa-times"></i></button>
                        </div>

                        <div class="row mb-2">
                            <div class="col-md-6 form-group mb-2">
                                <label class="small text-muted mb-1">Model Name <span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control form-control-sm" formControlName="modelName"
                                    placeholder="e.g. Standard Model">
                            </div>
                            <div class="col-md-12 form-group mb-2">
                                <label class="small text-muted mb-1">Model Description</label>
                                <textarea class="form-control form-control-sm" formControlName="description" rows="1"
                                    placeholder="Enter short model description"></textarea>
                            </div>
                        </div>

                        <!-- Nested Specs -->
                        <div class="mt-3 pl-3 border-left border-primary" formArrayName="specificationValues">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <span class="small font-weight-bold text-muted">Specifications</span>
                                <button type="button" class="btn btn-xs btn-link p-0 text-success"
                                    (click)="addSpec(mIndex)">+ Add Spec</button>
                            </div>

                            <div *ngFor="let spec of getSpecsArray(mIndex).controls; let sIndex = index"
                                [formGroupName]="sIndex" class="row align-items-center mb-2">
                                <!-- Spec dropdown bound to outer specificationId -->
                                <div class="col-4">
                                    <select class="form-control form-control-sm" formControlName="specificationId"
                                        (change)="onSpecSelected(mIndex, sIndex)">
                                        <option [ngValue]="0">Select Specification</option>
                                        <option *ngFor="let s of specifications" [ngValue]="s.id">{{ s.specName }}
                                        </option>
                                    </select>
                                </div>
                                <!-- Read-only fields auto-filled from selected spec -->
                                <ng-container formGroupName="specification">
                                    <div class="col-3">
                                        <input type="text" class="form-control form-control-sm" formControlName="type"
                                            readonly placeholder="Type">
                                    </div>
                                    <div class="col-2">
                                        <input type="text" class="form-control form-control-sm" formControlName="unit"
                                            readonly placeholder="Unit">
                                    </div>
                                </ng-container>

                                <!-- Value mapping to outer specificationValue object -->
                                <div class="col-2">
                                    <input type="text" class="form-control form-control-sm" formControlName="value"
                                        placeholder="Value">
                                </div>
                                <div class="col-1 text-right">
                                    <button type="button" class="btn btn-sm text-danger p-0"
                                        (click)="removeSpec(mIndex, sIndex)"><i class="fas fa-trash-alt"></i></button>
                                </div>
                            </div>

                            <div *ngIf="getSpecsArray(mIndex).length === 0" class="text-muted small font-italic py-1">
                                No specifications added for this model.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="custom-modal-footer mt-4 text-right">
                    <button type="button" class="btn btn-secondary mr-2" (click)="closeModal()">Cancel</button>
                    <button type="submit" class="btn btn-primary">
                        {{ isEditMode ? 'Update Product' : 'Save Product' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- View Product Modal -->
<div class="custom-modal-backdrop" *ngIf="isViewModalOpen && viewProduct">
    <div class="custom-modal custom-modal-xxl">
        <div class="custom-modal-header view-header">
            <h5 class="m-0"><i class="fas fa-box-open mr-2"></i>Product Details</h5>
            <button class="close-btn" (click)="closeViewModal()">&times;</button>
        </div>
        <div class="custom-modal-body">
            <!-- Product Info -->
            <div class="view-section mb-4">
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <span class="view-label">Product Name</span>
                        <p class="view-value">{{ viewProduct.productName }}</p>
                    </div>
                    <div class="col-md-6 mb-3">
                        <span class="view-label">Product Code</span>
                        <p class="view-value">{{ viewProduct.productCode }}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mb-3" *ngIf="viewProduct.description">
                        <span class="view-label">Description</span>
                        <p class="view-value">{{ viewProduct.description }}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 mb-3">
                        <span class="view-label">Category</span>
                        <p class="view-value">{{ viewProduct.categoryDetails?.categoryName || '—' }}</p>
                    </div>
                    <div class="col-md-4 mb-3">
                        <span class="view-label">Price</span>
                        <p class="view-value">₹{{ viewProduct.price }}</p>
                    </div>
                    <div class="col-md-4 mb-3">
                        <span class="view-label">Quantity</span>
                        <p class="view-value">{{ viewProduct.totalQuantity }}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 mb-3">
                        <span class="view-label">Availability</span>
                        <span class="badge"
                            [ngClass]="{'badge-success': viewProduct.availability === 'IN_STOCK', 'badge-warning': viewProduct.availability !== 'IN_STOCK'}">
                            {{ viewProduct.availability }}
                        </span>
                    </div>
                </div>

                <!-- Product Images Row -->
                <div class="row mt-3" *ngIf="viewProduct.imageDetails && viewProduct.imageDetails.length > 0">
                    <div class="col-12">
                        <span class="view-label d-block mb-2">Product Images</span>
                        <div class="d-flex flex-wrap gap-2">
                            <img *ngFor="let img of viewProduct.imageDetails"
                                [src]="getProductImageUrl(img.imageDetailsId)" alt="Product Image"
                                class="view-model-image mr-2 mb-2"
                                style="max-height: 100px; border-radius: 8px; border: 1px solid #ccc;">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Models Section -->
            <div *ngIf="viewProduct.models && viewProduct.models.length > 0">
                <hr>
                <h6 class="font-weight-bold text-primary mb-3"><i class="fas fa-layer-group mr-1"></i> Models &
                    Specifications</h6>

                <div *ngFor="let model of viewProduct.models; let mi = index"
                    class="view-model-card border rounded p-3 mb-3">
                    <div class="d-flex justify-content-between align-items-start mb-2">
                        <div>
                            <strong class="text-dark">{{ model.modelName }}</strong>
                            <span class="badge badge-light ml-2" *ngIf="model.powerSource">{{ model.powerSource
                                }}</span>
                        </div>
                        <span class="small text-muted" *ngIf="model.countryOfOrigin">
                            <i class="fas fa-globe-asia mr-1"></i>{{ model.countryOfOrigin }}
                        </span>
                    </div>

                    <p class="small text-muted mb-2" *ngIf="model.description">{{ model.description }}</p>

                    <!-- Model Image (DEPRECATED) -->
                    <!-- Currently viewing from product root instead -->

                    <!-- Specs Table -->
                    <div *ngIf="model.specificationValues && model.specificationValues.length > 0" class="mt-2">
                        <table class="table table-sm table-bordered mb-0">
                            <thead class="thead-light">
                                <tr>
                                    <th>Specification</th>
                                    <th>Type</th>
                                    <th>Value</th>
                                    <th>Unit</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let sv of model.specificationValues">
                                    <td>{{ sv.specification?.specName }}</td>
                                    <td><span class="badge badge-info">{{ sv.specification?.type }}</span></td>
                                    <td class="font-weight-bold">{{ sv.value }}</td>
                                    <td>{{ sv.specification?.unit || '—' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div *ngIf="!model.specificationValues || model.specificationValues.length === 0"
                        class="text-muted small font-italic mt-2">
                        No specifications for this model.
                    </div>
                </div>
            </div>

            <div *ngIf="!viewProduct.models || viewProduct.models.length === 0" class="text-muted font-italic mt-3">
                No models associated with this product.
            </div>

            <div class="custom-modal-footer mt-4 text-right">
                <button type="button" class="btn btn-secondary" (click)="closeViewModal()">Close</button>
            </div>
        </div>
    </div>
</div>